import { HttpService, BaseRepository } from '@Ravnur-Inc/http';

import pathes from '@Ravnur-Inc/shared/config/pathes';
import { Job$Response, Job } from '@Ravnur-Inc/shared/types/Job';

type JobsRepositoryQueryParams = {
  id: string[];
  mediaId: string[];
};

export default class JobsRepository extends BaseRepository<Job, JobsRepositoryQueryParams> {
  constructor() {
    super(pathes.JOB);
  }

  public async monitor(params: Record<string, unknown> = {}): Promise<Job$Response[]> {
    return HttpService.get(`${this._resource}/current`, { params });
  }

  public async cancel(jobId: string) {
    return HttpService.post(`${this._resource}/${jobId}/cancel`, {});
  }

  public async retry(jobId: string) {
    return HttpService.post(`${this._resource}/${jobId}/retry`, {});
  }

  public async delete(jobId: string) {
    return HttpService.delete(`${this._resource}/${jobId}`);
  }
}
